
// import Category from 'component/Category';
// import TopBanner from 'component/TopBanner';
// import React, { useEffect, useState } from 'react';
// import { Spin } from 'antd';
// import { SunOutlined, MoonOutlined } from '@ant-design/icons';
// import service from 'services/service';
// import { globalStore } from 'stores/globalStore';
// import "./landingPage.css"

// const LandingPage = () => {
//   const { landingPageData, setLandingPageData } = globalStore();
//   const [loading, setLoading] = useState(true);
//   const [isDarkMode, setIsDarkMode] = useState(() => {
//     const savedTheme = localStorage.getItem('theme');
//     return savedTheme === 'dark';
//   });

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
      
//       const [bannerResponse, spotlightProductResponse] = await Promise.all([
//         service.getAllBanners(),
//         service.getSpotLightProducts(),
//       ]);

//       console.log("Banner Response:", bannerResponse.data.data);
      
//       const banners = bannerResponse.data.data;
//       const topBanner = banners.topBanners?.[0] || null;
//       const middleBanner = banners.midBanners?.[0] || null;
//       const bottomBanner = banners.bottomBanners?.[0] || null;

//       setLandingPageData({
//         topBanners: topBanner,
//         middleBanners: middleBanner,
//         bottomBanners: bottomBanner,
//         spotLightProducts: spotlightProductResponse.data?.data || [],
//       });
      
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   // Toggle dark mode
//   const toggleDarkMode = () => {
//     const newMode = !isDarkMode;
//     setIsDarkMode(newMode);
//     localStorage.setItem('theme', newMode ? 'dark' : 'light');
//   };

//   // Apply theme on mount and when isDarkMode changes
//   useEffect(() => {
//     if (isDarkMode) {
//       document.documentElement.setAttribute('data-theme', 'dark');
//     } else {
//       document.documentElement.setAttribute('data-theme', 'light');
//     }
//   }, [isDarkMode]);

//   if (loading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Theme Toggle Button */}
//       <button className="theme-toggle-btn" onClick={toggleDarkMode} aria-label="Toggle theme">
//         {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
//       </button>
         
//       <div className='column-123'>
//         <Category />
//       </div>
      
//       <div className="landing">
//         {/* Top Banner - only render if has images */}
//         {landingPageData?.topBanners?.images?.length > 0 && <TopBanner />}
        
//         {/* Middle Banner - Add this if needed */}
//         {landingPageData?.middleBanners?.images?.length > 0 && (
//           <div className="middle-banner-container">
//             {/* Your middle banner component or JSX */}
//           </div>
//         )}
        
//         {/* Bottom Banner - Add this if needed */}
//         {landingPageData?.bottomBanners?.images?.length > 0 && (
//           <div className="bottom-banner-container">
//             {/* Your bottom banner component or JSX */}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default LandingPage;

// import Category from 'component/Category';
// import TopBanner from 'component/TopBanner';
// import React, { useEffect, useState } from 'react';
// import { Spin } from 'antd';
// import { SunOutlined, MoonOutlined } from '@ant-design/icons';
// import service from 'services/service';
// import { globalStore } from 'stores/globalStore';
// import "./landingPage.css"

// const LandingPage = () => {
//   const { landingPageData, setLandingPageData } = globalStore();
//   const [loading, setLoading] = useState(true);
//   const [isDarkMode, setIsDarkMode] = useState(() => {
//     const savedTheme = localStorage.getItem('theme');
//     return savedTheme === 'dark';
//   });

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
      
//       const [bannerResponse, spotlightProductResponse] = await Promise.all([
//         service.getAllBanners(),
//         service.getSpotLightProducts(),
//       ]);

//       console.log("Banner Response:", bannerResponse.data.data);
      
//       const banners = bannerResponse.data.data;
//       const topBanner = banners.topBanners?.[0] || null;
//       const middleBanner = banners.midBanners?.[0] || null;
//       const bottomBanner = banners.bottomBanners?.[0] || null;

//       setLandingPageData({
//         topBanners: topBanner,
//         middleBanners: middleBanner,
//         bottomBanners: bottomBanner,
//         spotLightProducts: spotlightProductResponse.data?.data || [],
//       });
      
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   // Toggle dark mode
//   const toggleDarkMode = () => {
//     const newMode = !isDarkMode;
//     setIsDarkMode(newMode);
//     localStorage.setItem('theme', newMode ? 'dark' : 'light');
//   };

//   // Apply theme on mount and when isDarkMode changes
//   useEffect(() => {
//     if (isDarkMode) {
//       document.documentElement.setAttribute('data-theme', 'dark');
//     } else {
//       document.documentElement.setAttribute('data-theme', 'light');
//     }
//   }, [isDarkMode]);

//   if (loading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Theme Toggle Button */}
//       <button className="theme-toggle-btn" onClick={toggleDarkMode} aria-label="Toggle theme">
//         {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
//       </button>
         
//       <div className='column-123'>
//         <Category />
//       </div>
      
//       <div className="landing">
//         {/* Top Banner - only render if has images */}
//         {landingPageData?.topBanners?.images?.length > 0 && <TopBanner />}
        
//         {/* Middle Banner - Add this if needed */}
//         {landingPageData?.middleBanners?.images?.length > 0 && (
//           <div className="middle-banner-container">
//             {/* Your middle banner component or JSX */}
//           </div>
//         )}
        
//         {/* Bottom Banner - Add this if needed */}
//         {landingPageData?.bottomBanners?.images?.length > 0 && (
//           <div className="bottom-banner-container">
//             {/* Your bottom banner component or JSX */}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default LandingPage;

import Category from 'component/Category';
import TopBanner from 'component/TopBanner';
import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import service from 'services/service';
import { globalStore } from 'stores/globalStore';
import SEO from 'component/SEO/SEO';
import "./landingPage.css"

const LandingPage = () => {
  const { landingPageData, setLandingPageData } = globalStore();
  const [loading, setLoading] = useState(true);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      
      const [bannerResponse, spotlightProductResponse] = await Promise.all([
        service.getAllBanners(),
        service.getSpotLightProducts(),
      ]);

      console.log("Banner Response:", bannerResponse.data.data);
      
      const banners = bannerResponse.data.data;
      const topBanner = banners.topBanners?.[0] || null;
      const middleBanner = banners.midBanners?.[0] || null;
      const bottomBanner = banners.bottomBanners?.[0] || null;

      setLandingPageData({
        topBanners: topBanner,
        middleBanners: middleBanner,
        bottomBanners: bottomBanner,
        spotLightProducts: spotlightProductResponse.data?.data || [],
      });
      
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Home"
        description="Rekha Collection (rekhacollection.in) - রেখা কালেকশন | Kolkata's #1 online fashion store at Hatgacha, Newtown. Buy saree, kurti, suit, blouse at lowest prices. Free delivery in Kolkata, West Bengal & all India. কলকাতার সেরা অনলাইন ফ্যাশন স্টোর। ☆ 7003981213"
        keywords="rekha collection official website, rekha collection online store, rekha collection saree, rekha collection kurti"
        url="/"
      />
      <div className='column-123'>
        <Category />
      </div>
      
      <div className="landing">
        {/* Top Banner - only render if has images */}
        {landingPageData?.topBanners?.images?.length > 0 && <TopBanner />}
        
        {/* Middle Banner - Add this if needed */}
        {landingPageData?.middleBanners?.images?.length > 0 && (
          <div className="middle-banner-container">
            {/* Your middle banner component or JSX */}
          </div>
        )}
        
        {/* Bottom Banner - Add this if needed */}
        {landingPageData?.bottomBanners?.images?.length > 0 && (
          <div className="bottom-banner-container">
            {/* Your bottom banner component or JSX */}
          </div>
        )}
      </div>
    </>
  );
};

export default LandingPage;